import moment from 'moment';

import { CustomFieldType } from '~/data/customData';
import { Enum, EnumListKey, useAllEnums } from '~/data/enums';
import { CustomDataItem } from '~/data/reports';

export const useGetCustomFieldValue = () => {
  const { getEnums } = useAllEnums();

  const getCustomFieldValue = (
    customField: CustomDataItem,
    customDataEnum: Enum | undefined,
  ): string => {
    switch (customDataEnum?.inputType?.value) {
      case CustomFieldType.BOOLEAN: {
        return customField.fCustomDataFieldValue[0];
      }
      case CustomFieldType.STRING: {
        return customField.fCustomDataFieldValue[0];
      }
      case CustomFieldType.DATE: {
        return moment(customField.fCustomDataFieldValue[0]).format(
          'DD-MM-YYYY',
        );
      }
      case CustomFieldType.NUMBER: {
        return customField.fCustomDataFieldValue[0];
      }
      case CustomFieldType.TEXT: {
        return customField.fCustomDataFieldValue[0];
      }
      case CustomFieldType.ENUM:
      case CustomFieldType.MULTISELECT: {
        const customDataSubItemEnum = getEnums(
          `__CUSTOMDATA__TIMESHEET__${customField.fCustomDataFieldName}` as EnumListKey,
        );

        return customDataSubItemEnum && !!customDataSubItemEnum.length
          ? customField.fCustomDataFieldValue
              .map((c) => {
                const customDataSubItem = customDataSubItemEnum.find(
                  (s) => s.code === c,
                );

                if (customDataSubItem) {
                  return customDataSubItem.name;
                }

                return c;
              })
              .join()
          : customField.fCustomDataFieldValue.join();
      }
      default:
        return customField.fCustomDataFieldValue[0];
    }
  };

  return { getCustomFieldValue };
};
